import React, { useEffect, useState } from 'react';
import CurrencyInput from '../../../../components/inputs/CurrencyInput';
import { TypeOfBonusesValues } from '../../../../app/models/Bonus';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { BonusRateDataForm } from '../../../../app/models/BonusRate';
import { Currency } from '../../../../app/models/Currency';
import { Item } from '../../../../app/models/Item';
import { Accordion, Card } from 'react-bootstrap';
import ToggleBox from '../../../../components/ToggleBox';

interface Props {
    bonusRateForm: BonusRateDataForm;
    setBonusRateForm: (bonus: BonusRateDataForm) => void;
    TypeOfBonuses: TypeOfBonusesValues[];
    currencies: Currency[];
    items?: Item[];
    errorFields?: any;
    setErrorFields?: (errors: any) => void;
    formulaItems?: string[]
}

const BonusRateForm = ({
    bonusRateForm,
    setBonusRateForm,
    TypeOfBonuses,
    currencies,
    items,
    errorFields,
    formulaItems,
    setErrorFields
}: Props) => {

    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();
    const [formula, setFormula] = useState<string>(bonusRateForm.formula ? bonusRateForm.formula : '');
    const [selectedItems, setSelectedItems] = useState<string[]>([]);

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    useEffect(() => {
        if (formulaItems) setSelectedItems([...formulaItems]);
    }, [formulaItems]);

    useEffect(() => {
        setBonusRateForm({ ...bonusRateForm, 'formula': `${formula}` });
    }, [formula]);

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;
        setBonusRateForm({ ...bonusRateForm, [name]: value });
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        const obj = { [name]: value };

        setBonusRateForm({ ...bonusRateForm, ...obj });
    };

    const handleCheckChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name } = event.target;
        if (name === 'is_taxable') {
            setBonusRateForm({
                ...bonusRateForm,
                is_taxable: !bonusRateForm.is_taxable
            });
        }
    };

    const handleSelectionChange = (
        key: string,
    ) => {
        setSelectedItems([...selectedItems, key])
        setFormula(prevFormula => prevFormula + `${key}`)
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        const lastChar = value.slice(-1);
        const validChars = /^[+\-*/().0-9%]*$/;
    
        if (validChars.test(lastChar)) {
            setFormula(`${formula}${lastChar}`)
        }
    };

    const isSelected = (key: string) => {
        if(selectedItems.find((item) => item === key)){
            return true
        }else {
            return false
        }
    };

    const cleanFormula = () => {
        setSelectedItems([]);
        setFormula('');
        setBonusRateForm({ ...bonusRateForm, 'formula': '' });
    }

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 mt-2 col-form-label">Tipo de bonificación</label>
                <div className="mt-3 col-md-9">
                    <SelectTwo
                        name="bonus_type"
                        id="bonus_type"
                        inputValue={bonusRateForm.bonus_type}
                        options={SelectTwoMapperOptions(TypeOfBonuses, 'id', ['name'])}
                        hasError={fieldHasError('bonus_type') !== ''}
                        onChange={(value: any) =>
                            handleChangeSelectTwo('bonus_type', value.value)
                        }
                        placeholder={'Seleccione el tipo de bonificación'}
                        onFocus={() => onFocusRemove('bonus_type')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('bonus_type')}
                    </div>
                </div>
            
                {bonusRateForm.bonus_type == 'Fijo' && 
                <>
                    <div className="col-md-6">
                        <label className="col-md-6 col-form-label">Monto</label>
                        <div className="col-md-12">
                            <CurrencyInput
                                name="value"
                                onFocus={() => onFocusRemove('value')}
                                className={`form-control ${fieldHasError('value')}`}
                                value={bonusRateForm.value}
                                onChange={handleChange}
                                placeholder="Ingrese valor"
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('value')}
                            </div>
                        </div>
                    </div>
                        <div className="col-md-6">
                            <label className="col-form-label">Moneda</label>
                            <SelectTwo
                                name="currency_id"
                                id="currency_id"
                                inputValue={bonusRateForm.currency_id}
                                options={SelectTwoMapperOptions(currencies)}
                                hasError={fieldHasError('currency_id') !== ''}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo('currency_id', value?.value)
                                }
                                placeholder={'Seleccione moneda'}
                                onFocus={() => onFocusRemove('currency_id')}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('currency_id')}
                            </div>
                        </div>
                    </>
                }

                {bonusRateForm.bonus_type == 'Porcentaje' && 
                    <>
                        <label className="col-md-6 col-form-label">Porcentaje</label>
                        <div className="col-md-6">
                            <input
                                type="value"
                                name="value"
                                id="value"
                                onFocus={() => onFocusRemove('value')}
                                className={`form-control ${fieldHasError('value')}`}
                                value={bonusRateForm.value}
                                onChange={handleChange}
                                placeholder="Ingrese valor"
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('value')}
                            </div>
                        </div>
                    </>
                }

                {bonusRateForm.bonus_type == 'Calculado' && items &&
                    <div className="col-md-12">
                        <label className="col-md-12 col-form-label">Items</label>
                        <Accordion>
                            {items.length ===0 ? (
                                <div className="mt-2 text-danger fw-bold">
                                    No se encontraron coincidencias
                                </div>
                            ) : (
                                items.map((item, index)=> {
                                    return (
                                        <Accordion.Item
                                            eventKey={`group${index}`}
                                            key={index}
                                        >
                                            <Accordion.Header>
                                                <span className="text-uppercase">{item.name}</span>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className="row pt-2">
                                                    {item.key_list &&
                                                        item.key_list.map(
                                                            (key_item, index) => {
                                                                return (
                                                                    <ToggleBox
                                                                        key={`permission${index}`}
                                                                        onClick={() => handleSelectionChange(key_item.key)}
                                                                        isSelected={isSelected(key_item.key)}
                                                                        title=""
                                                                        name={key_item.name}
                                                                        hover={key_item.hover}
                                                                    />
                                                                );
                                                            }
                                                        )
                                                    }
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                )})
                            )}
                        </Accordion>
                        <label className="col-md-9 col-form-label">Formula</label>
                        <div className="col-md-12 row">
                            <div className="col-md-9">
                                <input
                                    name="name"
                                    id="name"
                                    type="text"
                                    className={`form-control ${fieldHasError('name')}`}
                                    value={formula}
                                    onChange={handleInputChange}
                                    onFocus={() => onFocusRemove('name')}
                                    placeholder="Ingrese la formula"
                                />
                                <div className="invalid-feedback" style={{ display: 'flex' }}>
                                    {fieldErrorMessage('name')}
                                </div>
                            </div>
                            <button 
                                type="button"
                                className="btn btn-outline-light col-md-3"
                                onClick={() => cleanFormula()}
                            >
                                Borrar
                            </button>
                        </div>
                    </div>
                }

                <div className="my-4 row">
                    <div className="col-6">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="is_taxable"
                                value="true"
                                checked={bonusRateForm.is_taxable}
                                id="is_taxable"
                                onChange={handleCheckChange}
                            />
                            <label className="form-check-label" htmlFor="is_taxable">
                                Imponible
                            </label>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="is_taxable"
                                value="false"
                                checked={!bonusRateForm.is_taxable}
                                id="is_taxable"
                                onChange={handleCheckChange}
                            />
                            <label className="form-check-label" htmlFor="is_taxable">
                                No Imponible
                            </label>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <label className="col-md-6 col-form-label">Fecha de inicio</label>
                    <div className="col-md-12">
                        <input
                            type="month"
                            className={`form-control ${fieldHasError('valid_from')}`}
                            name="valid_from"
                            id="valid_from"
                            value={bonusRateForm.valid_from?.toString()}
                            onChange={handleChange}
                            placeholder="Ingrese una fecha"
                            onFocus={() => onFocusRemove('date')}
                        />
                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                            {fieldErrorMessage('valid_from')}
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <label className="col-md-9 col-form-label">Fecha de término</label>
                    <div className="col-md-12">
                        <input
                            type="month"
                            className={`form-control ${fieldHasError('valid_until')}`}
                            name="valid_until"
                            id="valid_until"
                            value={bonusRateForm.valid_until?.toString()}
                            onChange={handleChange}
                            placeholder="Ingrese una fecha"
                            onFocus={() => onFocusRemove('valid_until')}
                        />
                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                            {fieldErrorMessage('valid_until')}
                        </div>
                    </div>
                </div> 

                <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('non_field_errors')}
                </div>

            </div>
        </>
    );
};

export default BonusRateForm;

